import { Component, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxRadioGroupModule,
} from 'devextreme-angular';
import { getSizeQualifier } from 'src/app/services/screen.service';
import { AppointmentComplianceDto } from '@services';
import { YES_NO_OPTIONS } from 'src/app/shared/constants';

@Component({
    selector: 'compliance-form',
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        CommonModule,
        DxRadioGroupModule,
    ],
    templateUrl: './compliance-form.component.html',
})
export class ComplianceFormComponent {
    @Input() formData: AppointmentComplianceDto = {} as AppointmentComplianceDto;
    @Input() showTrailerRequired = false;
    @Input() isReadOnly = false;

    getSizeQualifier = getSizeQualifier;

    public yesNoOptions = YES_NO_OPTIONS;

    validateYesNo(params: { value: any }): boolean {
        return params.value !== null && params.value !== undefined;
    }
    
    getData = () => ({ ...this.formData }) as AppointmentComplianceDto;
}
